import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function QuickContactCta() {
  return <section data-section-id="84718" id="sedation-process" className="sticky bottom-0 z-50 w-full bg-gradient-to-r from-primary to-primary/90 text-white shadow-[0_-4px_10px_-2px_rgba(0,0,0,0.15)] md:relative md:shadow-none">
      <div className="container mx-auto px-4 py-3 md:py-6">
        <div className="flex flex-row items-center justify-between md:justify-center md:gap-16">
          
          {}
          <div className="hidden md:block">
            <Button asChild size="lg" className="h-14 rounded-full border-none bg-white px-8 text-lg font-semibold text-primary shadow-md transition-transform hover:scale-105 hover:bg-secondary">
              <Link to="sms:626-268-5990">
                <MessageCircle className="mr-2 size-6" />
                Text Our Team
              </Link>
            </Button>
          </div>

          {}
          <div className="flex flex-col items-start md:items-center">
            <span className="mb-0.5 text-[10px] font-semibold uppercase tracking-widest text-secondary-foreground/60 md:mb-1 md:text-sm">
              Safe Sedation & Support
            </span>
            <Link to="tel:+16264444444" className="group flex items-center gap-2 transition-opacity hover:opacity-90">
              <div className="rounded-full bg-white/20 p-1.5 transition-colors group-hover:bg-white/30 md:p-2">
                <Phone className="size-4 fill-current md:size-8" />
              </div>
              <span className="font-mono text-xl font-bold tracking-tight md:text-4xl">626-268-5990</span>
            </Link>
          </div>

          {}
          <div className="hidden md:block">
            <Button asChild size="lg" className="h-14 rounded-full border-none bg-accent px-8 text-lg font-semibold text-accent-foreground shadow-md transition-transform hover:scale-105 hover:bg-accent/90">
              <Link to="#">
                <SafeHydrate><Calendar className="mr-2 size-6" /></SafeHydrate>
                Book Consultation
              </Link>
            </Button>
          </div>

          {}
          <div className="flex items-center gap-2 md:hidden">
            <Button asChild size="icon" className="size-10 rounded-full bg-white text-primary shadow-sm hover:bg-secondary">
              <Link to="sms:626-268-5990" aria-label="Text Us">
                <MessageCircle className="size-5" />
              </Link>
            </Button>
            <Button asChild className="rounded-full bg-accent px-5 font-semibold text-accent-foreground shadow-sm hover:bg-accent/90">
              <Link to="#">
                Book
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}